import { adminLogin } from '../../../api/adminApi';
import { t, createField, isUnauthorized } from './context';
export function showLoginScreen(ctx) {
    ctx.screen.innerHTML = '';
    const title = document.createElement('h1');
    title.className = 'section-title admin__title';
    title.textContent = t('admin.login.title');
    const form = document.createElement('form');
    form.className = 'admin__form';
    const loginField = createField(t('admin.login.loginLabel'), 'text');
    loginField.input.autocomplete = 'username';
    const passwordField = createField(t('admin.login.passwordLabel'), 'password');
    passwordField.input.autocomplete = 'current-password';
    const error = document.createElement('p');
    error.className = 'admin__error';
    error.hidden = true;
    const submit = document.createElement('button');
    submit.type = 'submit';
    submit.className = 'cta admin__submit';
    submit.textContent = t('admin.login.submitLabel');
    form.append(loginField.wrapper, passwordField.wrapper, error, submit);
    form.addEventListener('submit', (event) => {
        event.preventDefault();
        error.hidden = true;
        const login = loginField.input.value.trim();
        const password = passwordField.input.value;
        if (!login || !password) {
            error.textContent = t('admin.login.missingFieldsError');
            error.hidden = false;
            return;
        }
        submit.disabled = true;
        submit.classList.add('is-loading');
        adminLogin(login, password)
            .then(() => ctx.showDashboard())
            .catch((err) => {
            const message = isUnauthorized(err) ? t('admin.login.invalidCredentialsError') : t('admin.login.genericError');
            error.textContent = message;
            error.hidden = false;
            submit.disabled = false;
            submit.classList.remove('is-loading');
        });
    });
    ctx.screen.append(title, form);
}
